export const isHeadersColumnValid = (headers) =>
  headers.some((header, i) => parseInt(header.key, 10) !== i)

export const hasHeadersColumns = (headers) => headers.length
